// Petit utilitaire de cache localStorage pour les listes (services, réalisations, etc.)
// Le cache permet un affichage instantané au chargement, puis l'API met à jour silencieusement.
//
// IMPORTANT : la version du cache est bumpée à chaque changement de schéma ou d'image
// par défaut. Bumper le numéro invalide TOUS les anciens caches sur tous les appareils.

const VERSION = "v3";
const PREFIX = `pizzelli_cache_${VERSION}::`;

// On purge silencieusement les anciennes versions au démarrage (1x par session)
try {
  if (typeof window !== "undefined" && window.localStorage) {
    const keys = Object.keys(window.localStorage);
    keys.forEach((k) => {
      if (/^pizzelli_cache_v\d+::/.test(k) && !k.startsWith(PREFIX)) {
        window.localStorage.removeItem(k);
      }
      // Anciens noms historiques également
      if (k === "pizzelli_settings_cache_v1" || k === "pizzelli_settings_cache_v2") {
        window.localStorage.removeItem(k);
      }
    });
  }
} catch {}

export function readCache(key, defaultValue = null) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return defaultValue;
    return JSON.parse(raw);
  } catch {
    return defaultValue;
  }
}

export function writeCache(key, value) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // quota dépassé (base64 trop volumineux) — on ignore
  }
}

export function clearCache(key) {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {}
}

export const CACHE_VERSION = VERSION;
